<!-- 进场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carLicenseNumber": "粤B88888",
                "cmd": "reportCarIn",
                "confidence": 97,
                "correctConfidence": 0,
                "correctType": 0,
                "enterCarCardNumber": "",
                "enterCarColor": 0,
                "enterCarLicenseColor": 1,
                "enterCarLicenseNumber": "粤B88888",
                "enterCarLicenseType": 0,
                "enterCarLogo": 0,
                "enterCarType": 1,
                "enterChannelId": 5628,
                "enterChannelCustomCode": "56228",
                "enterChannelName": "进口",
                "enterChargeGroupCode": "28",
                "enterCustomVipName": "",
                "enterImageArray": [
                    {
                        "carImage": "http://221.4.168.157:13388/openydt/files/images/2017092909505802078030-body-in-nor.jpg?s=c5635c04"
                    }
                ],
                "enterNovipCode": 1,
                "enterRecognitionConfidence": 97,
                "enterSpeed": 0,
                "enterStatisticalArea": "",
                "enterTime": "20170929095058",
                "enterType": 1,
                "enterVipRule": "",
                "enterVipType": 1,
                "inOperatorName": "System",
                "inOperatorTime": "20170929095059",
                "isCorrect": 0,
                "lastCorrectLicenseNumber": "",
                "lastCorrectName": "",
                "parkCode": "2KKN6111",
                "parkingCode": "2017092909505802078030",
                "recordType": 1,
                "remark": "",
                "openGateTime": 500,
                "thirdUserList":[{"userPhone":"18200946810"}]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报内部车场车辆进场信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportInternalParkingCarIn",
                precondition: "无",
                fitSystem: "智汇云-云车场 (上报图片保留90天)",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '最终车牌号' },
                        { info1: 'confidence', info2: '是', info3: 'Decimal', info4: '最终识别置信度' },
                        { info1: 'enterCarLicenseNumber', info2: '是', info3: 'String', info4: '进场车牌号' },
                        { info1: 'enterCarCardNumber', info2: '否', info3: 'String', info4: '进场卡号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        // { info1: 'enterChannelCode', info2: '否', info3: 'String', info4: '进场通道编码，云停车场为通道ID，VEMS为通道自定义编码' },
                        { info1: 'enterChannelId', info2: '否', info3: 'Long', info4: '进场通道ID' },
                        { info1: 'enterChannelCustomCode', info2: '否', info3: 'String', info4: '进场通道编码' },
                        { info1: 'enterChannelName', info2: '否', info3: 'String', info4: '进场通道名' },
                        { info1: 'enterVipType', info2: '是', info3: 'Integer', info4: '进场Vip类型（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '进场类型（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'enterSpeed', info2: '否', info3: 'Decimal', info4: '进场速度' },
                        { info1: 'enterCarLicenseColor', info2: '否', info3: 'Integer', info4: '进场车牌颜色（0未定义，1蓝色，2黄色，3白色，4黑色，5绿色）' },
                        { info1: 'enterCarColor', info2: '否', info3: 'Integer', info4: '进场车辆颜色（0未定义，1白色,2黑色,3红色,4绿色,5粉色,6蓝色,7紫色，8灰色,9雪青，10葱绿，11黄色，12橙色）' },
                        { info1: 'enterCarLogo', info2: '否', info3: 'Integer', info4: '进场车标' },
                        { info1: 'enterCarLicenseType', info2: '否', info3: 'Integer', info4: '进场车牌类型（0未定义，1蓝牌白字，2黄牌黑字，3黑牌白字，4白牌）' },
                        { info1: 'enterCarType', info2: '否', info3: 'Integer', info4: '车辆类型（0未知，1蓝牌车，2黄牌车"，3超大型车 4新能源小车，5新能源大车（vems：20 非机动车））' },
                        { info1: 'enterRecognitionConfidence', info2: '否', info3: 'Decimal', info4: '进场识别置信度' },
                        { info1: 'recordType', info2: '否', info3: 'Integer', info4: '记录类型（0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发）' },
                        { info1: 'isCorrect', info2: '是', info3: 'Integer', info4: '车牌是否被纠正（0未纠正，1已纠正）' },
                        { info1: 'correctConfidence', info2: '否', info3: 'Decimal', info4: '校正置信度' },
                        { info1: 'correctType', info2: '否', info3: 'Integer', info4: '校正类型（0未校正，1手动校正，2自动校正）' },
                        { info1: 'lastCorrectLicenseNumber', info2: '是', info3: 'String', info4: '最后校正校正车牌' },
                        { info1: 'lastCorrectName', info2: '否', info3: 'String', info4: '最后校正人名' },
                        { info1: 'lastCorrectTime', info2: '否', info3: 'String', info4: '最后校正时间，yyyyMMddHHmmss' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'inOperatorName', info2: '是', info3: 'String', info4: '进场放行操作员' },
                        { info1: 'inOperatorTime', info2: '是', info3: 'String', info4: '进场放行时间，yyyyMMddHHmmss' },
                        { info1: 'enterCustomVipName', info2: '否', info3: 'String', info4: '进场VIP名称' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONArray', info4: '进场图片列表，[{"carImage":"车身图片直接访问url"}] <br>'  + '注：智汇云不提供车牌图片(上报图片保留90天)' },
                        { info1: 'enterChargeGroupCode', info2: '否', info3: 'String', info4: '计费规则编码' },
                        { info1: 'openGateTime', info2: '否', info3: 'Integer', info4: '一体机抓拍到开闸的时长（单位：毫秒）。vems2.13以上支持' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        { info1: 'thirdUserList', info2: '否', info3: 'JSONArray', info4: '该车牌的第三方用户列表（是该合作方的用户才会上报，含义：必须是通过该授权商调用“第三方会员无缝嵌入智慧停车微信”登录智慧停车微信的用户，其车辆进出场消息才会含有手机号码）' },
                        { info1: 'enterStatisticalArea', info2: '否', info3: 'String', info4: '进场统计区域' },
                        { info1: 'enterNovipCode', info2: '否', info3: 'Integer', info4: '进场说明（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'extendInfo', info2: '否', info3: 'JSONObject', info4: '附加信息' },
                        { info1: 'fromAreaId', info2: '否', info3: 'String', info4: '来源区域：0为车场外部，其余为区域编码' },
                        { info1: 'toAreaId', info2: '是', info3: 'String', info4: '目的区域：0为车场外部，其余为区域编码' },
                        ]
                },{
                    titleName: 'thirdUserList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userPhone', info2: '是', info3: 'String', info4: '用户手机号' }
                        ]
                },{
                    titleName: 'extendInfo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'selfInCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
                        { info1: 'selfInUserUniqCode', info2: '是', info3: 'String', info4: '自助进场用户标识' },
                        { info1: 'selfOutCode', info2: '否', info3: 'String', info4: '自助出场随机码' },
                        { info1: 'selfOutUserUniqCode', info2: '否', info3: 'String', info4: '自助出场用户标识' },
                        { info1: 'enterNoVipCodeName', info2: '是', info3: 'String', info4: '进场说明（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'leaveNoVipCodeName', info2: '否', info3: 'String', info4: '出场说明（<url>参考附录:/Api/appendixData</url>）' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportInternalParkingCarIn.vue